import qs from 'qs';

export const ourBoxesItemPage = () => {
  const query = qs.stringify({
    populate: ['guideImage', 'boxBenefitsImage', 'boxBenefits'],
  });
  return '/our-boxes-item-page?' + query;
};
